export const ExclamationMarkModal = () => (
  <svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2210_213610)">
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
        fill={"#D71313"}
      />
      <g filter="url(#filter0_dd_2210_213610)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.8401 12.8809C18.8047 11.2272 21.1943 11.2272 22.1589 12.8809L28.0072 22.9066C28.9794 24.5732 27.7772 26.6662 25.8478 26.6662H14.1512C12.2218 26.6662 11.0196 24.5732 11.9918 22.9066L17.8401 12.8809ZM20.0003 16.6663C20.4606 16.6663 20.8337 17.0394 20.8337 17.4996V19.9996C20.8337 20.4598 20.4606 20.8329 20.0003 20.8329C19.5401 20.8329 19.167 20.4598 19.167 19.9996V17.4996C19.167 17.0394 19.5401 16.6663 20.0003 16.6663ZM18.9587 22.4996C18.9587 21.9243 19.425 21.4579 20.0003 21.4579C20.5756 21.4579 21.042 21.9243 21.042 22.4996C21.042 23.0749 20.5756 23.5413 20.0003 23.5413C19.425 23.5413 18.9587 23.0749 18.9587 22.4996Z"
          fill={"#FFFFFF"}
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_2210_213610"
        x="-6"
        y="2"
        width="52"
        height="52"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.164706 0 0 0 0.08 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2210_213610" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.152941 0 0 0 0 0.164706 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_2210_213610"
          result="effect2_dropShadow_2210_213610"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_2210_213610"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_2210_213610">
        <path
          d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z"
          fill={"#FFFFFF"}
        />
      </clipPath>
    </defs>
  </svg>
)

export default ExclamationMarkModal
